import eliteService from './../api/elite-service';
import redirect from '../uitls/redirect';
import { MESSAGES } from '../uitls/messages';
import { notifyError } from '../uitls/notification-helper';
import retry from '@/utils/retry';
import router from "@/router";
import userService from '../api/user-service';

const getState = () => {
    return {
        summary: { avgAccuracy: 0, totalCalories: 0, workoutTime: 0 },
        workoutHistory: null,
        loading: false,
        workoutLoading: false,
        joinDate: null,
        userProfileUpdateError: null,
        updateSuccessful: null,
        resetUpdateAlert: false,
        interests: [],
        lifeStyle:[],
        goals: [],
        weeklyExerciseData: { seconds: 0, calories: 0 }
    };
}

const state = getState();

const mutations = {
    setSummary(state, summary) {
        summary.rowCount = +summary.rowCount;
        let avgAccuracy = summary.rowCount ? (summary.avgAccuracy) / (summary.rowCount) : 0;
        summary.avgAccuracy = Math.round(avgAccuracy * 100)/100;

        state.summary = summary;
    },

    setWorkoutData(state, data) {
        state.workoutHistory = data
    },

    setLoading(state, val) {
        state.loading = val;
    },
    setWorkoutLoading(state, val) {
        state.workoutLoading = val;
    },

    setJoinDate(state, date) {
        state.joinDate = date;
    },

    setError(state, error) {
        state.userProfileUpdateError = error;
    },

    setUpdateSuccess(state, success) {
        state.updateSuccessful = success;
    },

    setupdateAlert(state, val) {
        state.resetUpdateAlert = val
    },
    setInterests(state, val){
        state.interests = val;
    },
    setLifeStyle(state, val){
        state.lifeStyle = val;
    },
    setGoals(state, val){
        state.goals = val;
    },
    setWeeklyExerciseData(state, val){
        state.weeklyExerciseData = val;
    }
}

const getters = {

};

const actions = {
    async loadUserWorkoutSummary({ commit }) {
        commit('setLoading', true);
        try {
            const summary = await eliteService.getWorkoutSummary();
            commit('setSummary', summary);
            commit('setLoading', false);
            return summary;
        } catch (e) {
            retry(e).then(async _ => {
                const summary = await eliteService.getWorkoutSummary();
                commit('setSummary', summary);
                commit('setLoading', false);
                return summary;
            }).catch(e => {
                commit('setLoading', false);
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async loadWorkoutData({ commit }) {
        commit('setWorkoutLoading', true);
        try {
            const data = await eliteService.getWorkoutData();
            commit('setJoinDate', data.joinDate);
            commit('setWorkoutData', data.rows);
            commit('setWorkoutLoading', false);
            return data;
        } catch (e) {
            retry(e).then(async _ => {
                const data = await eliteService.getWorkoutData();
                commit('setJoinDate', data.joinDate);
                commit('setWorkoutData', data.rows);
                commit('setWorkoutLoading', false);
                return data;
            }).catch(e => {
                commit('setWorkoutLoading', false);
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async updateUser({ commit }, data) {
        commit('setLoading', true);
        commit('setError', "");
        try {
            let res = await userService.updateUser(data);
            
            if (res && res.message == "sameOldPassword") {
                commit('setError', MESSAGES.SAME_OLD_PASSWORD);
            }
            if(res.status == 200){
                if(res && res?.data?.message === "incorrectPassword"){
                    commit('setError', MESSAGES.INCORRECT_PASSWORD);
                }else{
                    commit('setUpdateSuccess', MESSAGES.PROFILE_UPDATED)
                }
            }   
            else{
                commit('setError', MESSAGES.SET_DETAILS_FAILED);
            }
            
        }
        catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.SET_DETAILS_FAILED)
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },
    async getUserSetupDetails({ commit }) {
        commit('setLoading', true);
        try {
            let res = await userService.getUserProfileSetupDetails();
            if(res.status == 200){
                commit('setInterests', res.data.interests);
                commit('setLifeStyle', res.data.lifestyle);
                commit('setGoals', res.data.goals);
            }
        }
        catch (err) {
            commit('setLoading', false);
            commit('setError', MESSAGES.RESET_FAILED)
            redirect(err);
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },


    async firstLogin({ commit }) {
        try {
            await userService.firstLogin();
        }
        catch (err) {
            redirect(err);
            throw err;
        } finally {
        }
    },

    async getUserExerciseDetails({ commit }) {
        let res = userService.getUserExerciseDetails();
        if (res.status == 200) {
            commit('setWeeklyExerciseData', res.data);
        }
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {

    }
}
